import { z } from "zod";

export const QuickReplySchema = z.object({
  created_at: z.string(),
  id: z.number(),
  text: z.string(),
  updated_at: z.string(),
  user_id: z.number(),
});
export type QuickReply = z.infer<typeof QuickReplySchema>;

export const QuickRepliesResponseSchema = z.array(QuickReplySchema);
export type QuickRepliesResponse = z.infer<typeof QuickRepliesResponseSchema>;

const DeleteQuickReplyArgsSchema = z.object({
  id: z.number(),
  userID: z.number(),
});
export type DeleteQuickReplyArgs = z.infer<typeof DeleteQuickReplyArgsSchema>;

export const PostQuickReplyArgsSchema = z.object({
  text: z.string().min(1),
  userID: z.number(),
});
export type PostQuickReplyArgs = z.infer<typeof PostQuickReplyArgsSchema>;
